import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'

const IncidentReportsTable = ({
    incidentReports
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Site',
                accessorKey: 'dutyLog.site.name'
            },
            {
                header: 'Security Officer',
                accessorKey: 'officer.name'
            },
            {
                header: 'Incident Type',
                accessorKey: 'type'
            },
            {
                header: 'Incident Time',
                accessorKey: 'incident_time'
            },
            {
                header: 'Longitude',
                accessorKey: 'longitude'
            },
            {
                header: 'Latitude',
                accessorKey: 'latitude'
            }
        ],
        []
    );

    const table = useReactTable({
        data: incidentReports,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (incidentReports.length === 0){
        return <div className="text-center">No incident reports found</div>
    }
  return (
    <table className='table table-striped table-responsive'>
        <thead>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
                    ))}
                </tr>
            ))}
        </thead>
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                    ))}
                </tr>
            ))}
        </tbody>
    </table>
  )
}

export default IncidentReportsTable